// Track page views on route updates (for SPA navigation)
exports.onRouteUpdate = ({ location, prevLocation }) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        // Track page view
        window.gtag('event', 'page_view', {
            page_path: location.pathname + location.search + location.hash,
            page_location: window.location.href,
        });

        // Log for debugging
        console.log('GA Page View:', location.pathname);
    }
};

